/* Carrito B intenso: mutaciones serializadas y vistas renderizadas por Shopify. */
(() => {
  'use strict';
  window.HS = window.HS || {};
  const raiz = window.Shopify?.routes?.root || '/';
  const fetchOriginal = window.HS._fetchOriginal || window.fetch;
  let cola = Promise.resolve();
  let pendientes = 0;
  const borradores = new Map();
  let disparador;
  let ultimoActivador;
  document.addEventListener('click', evento => {
    const activador = evento.target.closest?.('[data-hs-submit], [data-hs-submit-fijo], [data-hs-agregar], .hs-encabezado__carrito, .hs-barra-inferior a[href$="/cart"]');
    if (activador) ultimoActivador = activador;
  }, true);
  let scrollPrevio = '';
  const dialogo = () => document.getElementById('hs-carrito');
  function cerrar() {
    if (!dialogo()?.open) return;
    dialogo().close();
  }
  function despuesDeCerrar() {
    document.body.style.overflow = scrollPrevio;
    const destino = disparador?.isConnected ? disparador : document.querySelector('.hs-encabezado__carrito');
    destino?.focus({ preventScroll: true });
    disparador = null;
    ultimoActivador = null;
    document.querySelectorAll('[aria-controls="hs-carrito"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
  }
  function abrir() {
    if (document.querySelector('[data-hs-carrito-pagina]') || !dialogo() || dialogo().open) return;
    const activo = document.activeElement;
    disparador = ultimoActivador?.isConnected ? ultimoActivador :
      (activo && activo !== document.body && activo !== document.documentElement && !dialogo().contains(activo) ? activo : null);
    scrollPrevio = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialogo().showModal();
    moverAviso();
    dialogo().querySelector('[data-hs-carrito-cerrar]').focus();
    document.querySelectorAll('[aria-controls="hs-carrito"]').forEach(el => el.setAttribute('aria-expanded', 'true'));
  }
  async function pedir(ruta, datos) {
    let respuesta;
    for (let intento = 0; ; intento++) {
      respuesta = await fetchOriginal.call(window, raiz + ruta, {
        method: datos ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', ...(datos ? { 'Content-Type': 'application/json' } : {}) },
        ...(datos ? { body: JSON.stringify(datos) } : {})
      });
      if (respuesta.status !== 429 || intento === 3) break;
      await new Promise(resolve => setTimeout(resolve, 3000 * 2 ** intento));
    }
    const dato = await respuesta.json();
    if (!respuesta.ok) throw new Error(dato.description || 'No se pudo actualizar el carrito.');
    return dato;
  }
  function marcarPendiente() {
    document.querySelectorAll('[data-hs-checkout]').forEach(el => {
      if (pendientes) {
        el.setAttribute('aria-busy', 'true');
        el.setAttribute('aria-disabled', 'true');
        if (el.tagName === 'BUTTON') el.disabled = true;
      } else {
        el.removeAttribute('aria-busy');
        el.removeAttribute('aria-disabled');
        if (el.tagName === 'BUTTON') el.disabled = false;
      }
    });
  }
  function serializar(tarea) {
    pendientes++;
    marcarPendiente();
    const resultado = cola.then(tarea).finally(() => { pendientes--; marcarPendiente(); });
    cola = resultado.catch(() => {});
    return resultado;
  }
  function contextoSecciones() {
    const pagina = document.querySelector('[data-hs-carrito-pagina]');
    return { ids: ['hs-carrito-lateral', ...(pagina ? [pagina.dataset.hsSeccion] : [])], contexto: pagina ? `${raiz}cart` : raiz };
  }
  function identidadFoco(el, region) {
    if (!el || !region.contains(el)) return null;
    const linea = el.closest('[data-hs-linea]');
    const base = linea ? `[data-hs-linea="${CSS.escape(linea.dataset.hsLinea)}"] ` : '';
    if (el.id) return `#${CSS.escape(el.id)}`;
    const atributos = [...el.attributes].filter(a => (a.name.startsWith('data-') && a.name !== 'data-hs-cantidad-real') || ['name', 'href', 'aria-controls'].includes(a.name));
    return base + el.tagName.toLowerCase() + atributos.map(a => `[${a.name}="${CSS.escape(a.value)}"]`).join('');
  }
  function pintar(secciones) {
    const { ids } = contextoSecciones();
    // Validar todo antes de tocar el DOM, también cuando Shopify devuelve null con HTTP 200.
    const vistas = ids.map(id => {
      if (!secciones?.[id]) throw new Error('No se pudo mostrar el carrito actualizado.');
      const selector = id === 'hs-carrito-lateral' ? '#hs-carrito' : '[data-hs-carrito-pagina]';
      const nuevo = new DOMParser().parseFromString(secciones[id], 'text/html').querySelector(selector);
      if (!nuevo) throw new Error('No se pudo mostrar el carrito actualizado.');
      return [document.querySelector(selector), nuevo];
    });
    for (const [anterior, nuevo] of vistas) {
      if (!anterior) continue;
      const activo = anterior.contains(document.activeElement) ? document.activeElement : null;
      const identidad = identidadFoco(activo, anterior);
      const seleccion = activo && /^(INPUT|TEXTAREA)$/.test(activo.tagName) ? [activo.selectionStart, activo.selectionEnd] : null;
      // Guardar solo ediciones sin enviar; las líneas en vuelo deben aceptar la cantidad confirmada.
      const cantidades = new Map();
      anterior.querySelectorAll('[data-hs-cantidad]').forEach(campo => {
        const linea = campo.closest('[data-hs-linea]');
        if (linea.getAttribute('aria-busy') !== 'true' && campo.value !== campo.dataset.hsCantidadReal) {
          cantidades.set(linea.dataset.hsLinea, campo.value);
        }
      });
      const listaScroll = anterior.querySelector('.hs-carrito-lateral__lista')?.scrollTop;
      if (anterior.matches('[data-hs-carrito-pagina]')) {
        const form = anterior.querySelector('form');
        const siguiente = nuevo.querySelector('form');
        anterior.querySelectorAll('[name="note"], [name="discount"]').forEach(el => borradores.set(el.name, el.value));
        if (form && siguiente) {
          anterior.querySelector('[data-hs-lineas]').replaceChildren(...nuevo.querySelector('[data-hs-lineas]').childNodes);
          anterior.querySelector('.hs-carrito__resumen').replaceChildren(...nuevo.querySelector('.hs-carrito__resumen').childNodes);
        } else {
          // Solo cambia el bloque del carrito al pasar entre vacío y lleno; sugeridos permanece intacto.
          const previo = form || anterior.querySelector('.hs-carrito-vacio');
          previo.replaceWith(siguiente || nuevo.querySelector('.hs-carrito-vacio'));
          anterior.querySelectorAll('[name="note"], [name="discount"]').forEach(el => { if (borradores.has(el.name)) el.value = borradores.get(el.name); });
        }
      } else {
        anterior.querySelector('[data-hs-carrito-conteo]').textContent = nuevo.querySelector('[data-hs-carrito-conteo]').textContent;
        const lista = anterior.querySelector('.hs-carrito-lateral__lista');
        const siguiente = nuevo.querySelector('.hs-carrito-lateral__lista');
        if (lista && siguiente) {
          lista.replaceChildren(...siguiente.childNodes);
          anterior.querySelector('.hs-carrito-lateral__pie').replaceChildren(...nuevo.querySelector('.hs-carrito-lateral__pie').childNodes);
        } else {
          anterior.querySelectorAll('.hs-carrito-lateral__lista, .hs-carrito-lateral__pie, .hs-carrito-vacio').forEach(el => el.remove());
          [...nuevo.children].filter(el => el.matches('.hs-carrito-lateral__lista, .hs-carrito-lateral__pie, .hs-carrito-vacio')).forEach(el => anterior.append(el));
        }
      }
      anterior.querySelectorAll('[data-hs-cantidad]').forEach(campo => {
        const key = campo.closest('[data-hs-linea]').dataset.hsLinea;
        if (cantidades.has(key)) campo.value = cantidades.get(key);
      });
      if (listaScroll != null && anterior.querySelector('.hs-carrito-lateral__lista')) anterior.querySelector('.hs-carrito-lateral__lista').scrollTop = listaScroll;
      if (activo && !activo.isConnected) {
        const destino = anterior.querySelector(identidad) || anterior.querySelector('[data-hs-carrito-cerrar], button, a[href]');
        destino?.focus({ preventScroll: true });
        if (seleccion && seleccion[0] != null && destino?.setSelectionRange) destino.setSelectionRange(...seleccion);
      }
    }
    marcarPendiente();
    document.body.dispatchEvent(new CustomEvent('contentUpdated', { bubbles: true }));
  }
  async function leerSecciones() {
    const { ids, contexto } = contextoSecciones();
    const respuesta = await fetchOriginal.call(window, `${contexto}?sections=${ids.map(encodeURIComponent).join(',')}`, { cache: 'no-store' });
    if (!respuesta.ok) throw new Error('No se pudo mostrar el carrito actualizado.');
    return respuesta.json();
  }
  async function repintar(secciones) {
    try { pintar(secciones || await leerSecciones()); }
    catch (_) {
      // Un único reintento de presentación; nunca convierte un POST exitoso en un error de compra.
      try { pintar(await leerSecciones()); }
      catch (error) { console.warn('HS: carrito guardado; no se pudo actualizar la vista.', error); }
    }
  }
  function emitir(cart) {
    document.dispatchEvent(new CustomEvent('hs:carrito-actualizado', { detail: { cart } }));
  }
  async function refrescar() {
    const cart = await pedir('cart.js');
    await repintar();
    emitir(cart);
  }
  async function mutar(ruta, datos) {
    const { ids, contexto } = contextoSecciones();
    let resultado;
    try { resultado = await pedir(ruta, { ...datos, sections: ids, sections_url: contexto }); }
    catch (error) {
      try { await refrescar(); } catch (_) { /* Mantener el error original de la mutación. */ }
      throw error;
    }
    let cart = resultado;
    if (!Array.isArray(resultado.items) || typeof resultado.item_count !== 'number') {
      // add.js devuelve artículos, no Cart: aprovechar el snapshot del render incluido.
      const html = resultado.sections?.['hs-carrito-lateral'];
      try {
        const json = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hs-carrito-json]');
        cart = json ? JSON.parse(json.textContent) : await pedir('cart.js');
      } catch (_) {
        try { cart = await pedir('cart.js'); }
        catch (error) { console.warn('HS: no se pudo leer el carrito guardado.', error); }
      }
    }
    await repintar(resultado.sections);
    if (typeof cart.item_count === 'number') emitir(cart);
    return cart;
  }
  window.HS.carrito = {
    abrir, cerrar,
    agregar(id, cantidad) { return serializar(() => mutar('cart/add.js', { items: [{ id, quantity: cantidad }] })); },
    cambiar(key, cantidad) { return serializar(() => mutar('cart/change.js', { id: key, quantity: cantidad })); },
    refrescar() { return serializar(refrescar); }
  };
  dialogo()?.addEventListener('close', despuesDeCerrar);
  if (!document.querySelector('[data-hs-carrito-pagina]')) document.querySelectorAll('.hs-encabezado__carrito, .hs-barra-inferior a[href$="/cart"]').forEach(el => {
    el.setAttribute('aria-controls', 'hs-carrito');
    el.setAttribute('aria-haspopup', 'dialog');
    el.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('click', evento => {
    if (!(evento.target instanceof Element)) return;
    const enlace = evento.target.closest('.hs-encabezado__carrito, .hs-barra-inferior a[href$="/cart"]');
    if (enlace) { evento.preventDefault(); abrir(); return; }
    if (evento.target.closest('[data-hs-carrito-cerrar]')) cerrar();
    if (evento.target === dialogo()) {
      const caja = dialogo().getBoundingClientRect();
      if (evento.clientX < caja.left || evento.clientX > caja.right || evento.clientY < caja.top || evento.clientY > caja.bottom) cerrar();
    }
    const accion = evento.target.closest('[data-hs-cantidad-paso], [data-hs-quitar]');
    if (!accion) return;
    evento.preventDefault();
    const linea = accion.closest('[data-hs-linea]');
    const campo = linea.querySelector('[data-hs-cantidad]');
    const cantidad = accion.hasAttribute('data-hs-quitar') ? 0 : Math.max(0, Number(campo.dataset.hsCantidadReal) + Number(accion.dataset.hsCantidadPaso));
    cambiarLinea(linea, cantidad);
  });
  document.addEventListener('change', evento => {
    if (evento.target.matches('[data-hs-cantidad]')) cambiarCampo(evento.target);
  });
  function cambiarCampo(campo) {
    const cantidad = Number(campo.value);
    if (!campo.value.trim() || !Number.isInteger(cantidad) || cantidad <= 0) {
      campo.value = campo.dataset.hsCantidadReal;
      return;
    }
    if (cantidad !== Number(campo.dataset.hsCantidadReal)) cambiarLinea(campo.closest('[data-hs-linea]'), cantidad);
  }
  async function cambiarLinea(linea, cantidad) {
    if (!Number.isInteger(cantidad) || cantidad < 0 || linea.getAttribute('aria-busy') === 'true') return;
    const key = linea.dataset.hsLinea;
    linea.setAttribute('aria-busy', 'true');
    try { await window.HS.carrito.cambiar(key, cantidad); }
    catch (error) {
      document.querySelectorAll('[data-hs-linea]').forEach(el => {
        if (el.dataset.hsLinea !== key) return;
        const aviso = el.querySelector('[data-hs-linea-error]'); aviso.textContent = error.message; aviso.hidden = false;
      });
      const aviso = document.querySelector('[data-hs-carrito-error]');
      if (aviso && ![...document.querySelectorAll('[data-hs-linea]')].some(el => el.dataset.hsLinea === key)) { aviso.textContent = error.message; aviso.hidden = false; }
    } finally {
      linea.removeAttribute('aria-busy');
      // Si falló también la lectura de recuperación, restaurar el último valor confirmado.
      if (linea.isConnected) linea.querySelector('[data-hs-cantidad]').value = linea.querySelector('[data-hs-cantidad]').dataset.hsCantidadReal;
    }
  }
  function moverAviso() {
    if (!dialogo()?.open) return;
    document.querySelectorAll('body > .hs-checkout-aviso').forEach(el => dialogo().append(el));
  }
  new MutationObserver(moverAviso).observe(document.body, { childList: true });
  // Captura en window antes del interceptor de checkout (document, capture).
  window.addEventListener('click', evento => {
    if (pendientes && evento.target.closest?.('[data-hs-checkout]')) {
      evento.preventDefault();
      evento.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', evento => {
    if (pendientes && evento.target.matches('.hs-carrito__form')) evento.preventDefault();
  }, true);
  document.addEventListener('keydown', evento => {
    if (evento.key === 'Enter' && evento.target.matches('[data-hs-cantidad]')) {
      evento.preventDefault();
      cambiarCampo(evento.target);
    }
    if (!dialogo()?.open || evento.key !== 'Tab') return;
    const elementos = [...dialogo().querySelectorAll('a[href],button,input,textarea,select,[tabindex]')].filter(el =>
      el.tabIndex >= 0 && !el.matches(':disabled') && !el.closest('[inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    const primero = elementos[0], ultimo = elementos[elementos.length - 1];
    if (!primero) { evento.preventDefault(); dialogo().focus(); return; }
    if (evento.shiftKey && (document.activeElement === primero || !elementos.includes(document.activeElement))) { evento.preventDefault(); ultimo.focus(); }
    else if (!evento.shiftKey && (document.activeElement === ultimo || !elementos.includes(document.activeElement))) { evento.preventDefault(); primero.focus(); }
  }, true);
})();
